import React, {useState} from "react";
import {Controller, useForm} from "react-hook-form";
import {useQueryClient} from "react-query";
import {useNavigate} from "react-router-dom";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {tokenSelector} from "../../Recoil/Atom/authState";

import * as userApi from "../../api/userApi/userApi";

import {useCreateMutation, useGetQuery, useRemoveMutation} from "../../hooks/useQueryHooks";
import {
  ResponseFile,
  ResponseList,
  ResponseRemove,
} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";

import {
  Box,
  Button,
  Link,
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled,
} from "@mui/material";
import {alertStateAtom, extraAlertStateAtom} from "../../Recoil/Atom/AlertAtom";
import MWSkeleton from "../../components/MWSkeleton";
import SubTitle from "../../components/SubTitle";
import {useDepartmentList} from "../../hooks/useDepartmentList";
import {EQUser, initializeUserListParams, userListParams} from "../../models/serverModels/EQUser";
import {
  StyledButton,
  StyledButtonGroup,
  SubMenuGroup,
} from "../../styledComponents/StyledListContainer";
import LibraryAddIcon from "@mui/icons-material/LibraryAdd";
import {ReactComponent as ExcelIcon} from "../../assets/images/excel.svg";

import {PaginationContainer} from "../../styledComponents/StyledPagination";
import {StyledTableContainer, StyledTableHead} from "../../styledComponents/StyledTable";
const ListContainer = styled(Box)(({theme}) => ({
  minWidth: "1200px",
}));

const BoardManagerList = () => {
  const tokenState = useRecoilValue(tokenSelector);

  const [page, setPage] = useState<number>(1);

  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const setAlertState = useSetRecoilState(alertStateAtom);
  const {departmentList} = useDepartmentList();

  const rows = 30;

  const {
    data: OfficerList,
    isLoading,
    isFetching,
  } = useGetQuery<ResponseList<EQUser>>({
    key: ["BoardManagerList", {token: tokenState, page, rows}],
    api: () => userApi.BoardManagerList({token: tokenState, page, rows}),
  });

  const {mutate: removeMutate} = useRemoveMutation<ResponseRemove, Params.Remove>({
    api: userApi.remove,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries("BoardManagerList");
      },
    },
  });

  const paginationHandleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };
  return (
    <ListContainer>
      <SubTitle subTitle="게시판 담당자 목록" />
      <SubMenuGroup>
        <Box></Box>
        <StyledButtonGroup>
          <StyledButton
            variant="outlined"
            size="medium"
            color="primary"
            startIcon={<LibraryAddIcon />}
            sx={{whiteSpace: "nowrap", flexShrink: 0}}
            onClick={() => navigate("/BoardManager/Create")}
          >
            새로추가
          </StyledButton>
        </StyledButtonGroup>
      </SubMenuGroup>
      <StyledTableContainer>
        <Table>
          <StyledTableHead>
            <TableRow>
              <TableCell align="center">#</TableCell>
              <TableCell align="center">이름</TableCell>
              <TableCell align="center">이메일</TableCell>
              <TableCell align="center">아이디</TableCell>
              <TableCell align="center">비밀번호</TableCell>
              <TableCell align="center">작성날짜</TableCell>
              <TableCell align="center">수정날짜</TableCell>
              <TableCell align="center" width="15%">
                편집
              </TableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {isLoading && isFetching ? (
              <MWSkeleton row={12} column={8} />
            ) : (
              OfficerList?.items.map((item, index) => (
                <TableRow key={item.uid}>
                  <TableCell align="center">
                    {/* {page === 1
                      ? index + 1
                      : (page - 1) * initializeUserListParams().rows! + index + 1} */}
                    {(page - 1) * rows + index + 1}
                  </TableCell>

                  <TableCell align="center">{item.name}</TableCell>
                  <TableCell align="center">{item.email}</TableCell>
                  <TableCell align="center">{item.loginID}</TableCell>
                  <TableCell align="center">{item.loginPW}</TableCell>
                  <TableCell align="center">
                    {new Date(item?.registerDate).getFullYear()}년
                    {new Date(item?.registerDate).getMonth() + 1}월
                    {new Date(item?.registerDate).getDate()}일
                  </TableCell>
                  <TableCell align="center">
                    {new Date(item?.modifyDate).getFullYear()}년
                    {new Date(item?.modifyDate).getMonth() + 1}월
                    {new Date(item?.modifyDate).getDate()}일
                  </TableCell>

                  <TableCell align="center">
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      style={{marginRight: "12px"}}
                      onClick={() => {
                        navigate(`/BoardManager/Edit/${item.uid}`);
                      }}
                    >
                      편집
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="small"
                      onClick={() => {
                        setAlertState({
                          toggle: true,
                          message: "등록된 담당자를 삭제하시겠습니까?",
                          execution: () => removeMutate({token: tokenState, id: item.uid!}),
                        });
                      }}
                    >
                      삭제
                    </Button>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
      {/* 페이지네이션 */}
      <PaginationContainer>
        <Pagination
          count={OfficerList?.maxPage}
          page={page}
          onChange={paginationHandleChange}
          variant="outlined"
          color="primary"
          shape="rounded"
        />
      </PaginationContainer>
    </ListContainer>
  );
};

export default BoardManagerList;
